import { render, staticRenderFns } from "./SocialShareMetaTagsFormField.vue?vue&type=template&id=a6a04ccc&scoped=true"
import script from "./SocialShareMetaTagsFormField.vue?vue&type=script&lang=js"
export * from "./SocialShareMetaTagsFormField.vue?vue&type=script&lang=js"
import style0 from "./SocialShareMetaTagsFormField.vue?vue&type=style&index=0&id=a6a04ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a04ccc",
  null
  
)

export default component.exports